// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as SecurityPasswordActions } from '../duck';
import { actions as AlertActions } from '../../../alert/duck';
import Security from '../components/Security';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    isPuttingEmail: state.preferences.security.isPuttingEmail,
    editSuccessful: state.preferences.security.editSuccessful,
    putEmailError: state.preferences.security.putEmailError,
    isPostingPhone: state.preferences.security.isPostingPhone,
    postPhoneError: state.preferences.security.postPhoneError,
    isPostingCode: state.preferences.security.isPostingCode,
    successfulVerification: state.preferences.security.successfulVerification,
    postCodeError: state.preferences.security.postCodeError,
    user: state.auth.user,
    localValues: state.localValues,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...SecurityPasswordActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Security);



// WEBPACK FOOTER //
// ./src/modules/preferences/security/containers/SecurityContainer.js